import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc", color: "#1e293b", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif" }}>
      {/* Header */}
      <header style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, zIndex: 10 }}>
        <div style={{ maxWidth: "900px", margin: "0 auto", padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "22px", fontWeight: "700", color: "#2563eb", letterSpacing: "-0.5px" }}>Phloz</span>
            <span style={{ fontSize: "14px", color: "#64748b", borderLeft: "1px solid #cbd5e1", paddingLeft: "12px" }}>Terms of Service</span>
          </div>
          <Link
            to="/login"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#2563eb",
              textDecoration: "none",
              padding: "6px 14px",
              borderRadius: "6px",
              border: "1px solid #bfdbfe",
              backgroundColor: "#eff6ff"
            }}
          >
            Go to App
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main style={{ maxWidth: "900px", margin: "0 auto", padding: "40px 24px 80px" }}>
        <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e2e8f0", padding: "48px 40px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <h1 style={{ fontSize: "32px", fontWeight: "800", color: "#0f172a", marginBottom: "8px", letterSpacing: "-0.5px" }}>
            Phloz Terms of Service
          </h1>
          <p style={{ color: "#64748b", fontSize: "14px", marginBottom: "32px" }}>
            <strong>Effective Date:</strong> January 1, 2026 | <strong>Last Updated:</strong> October 23, 2026
          </p>

          <section style={{ marginBottom: "32px", lineHeight: "1.7" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using Phloz (the "Service"), provided by TBP Labs, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not access or use the Service.
            </p>
          </section>

          <section style={{ marginBottom: "32px", lineHeight: "1.7" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>
              2. Description of Service
            </h2>
            <p>
              Phloz provides communication automation, email outreach management, workflow coordination, and analytics tools. Phloz connects with third-party messaging and email services (such as Google Workspace and Gmail) upon authorized user configuration.
            </p>
          </section>

          <section style={{ marginBottom: "32px", lineHeight: "1.7" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>
              3. Acceptable Use and Anti-Spam Policy
            </h2>
            <p style={{ marginBottom: "12px" }}>
              You agree to use Phloz in strict compliance with all applicable laws, including the CAN-SPAM Act, the General Data Protection Regulation (GDPR), and all relevant anti-spam regulations.
            </p>
            <ul style={{ paddingLeft: "24px" }}>
              <li style={{ marginBottom: "8px" }}>You will only send emails to individuals with whom you have an existing relationship or legitimate business interest.</li>
              <li style={{ marginBottom: "8px" }}>You will honor all unsubscribe and opt-out requests immediately.</li>
              <li style={{ marginBottom: "8px" }}>You will not send deceptive, fraudulent, illegal, or harassing content through the platform.</li>
              <li style={{ marginBottom: "8px" }}>You will not attempt to bypass rate limits or system security safeguards.</li>
            </ul>
          </section>

          <section style={{ marginBottom: "32px", lineHeight: "1.7" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>
              4. Third-Party Integrations & Google API Compliance
            </h2>
            <p style={{ marginBottom: "12px" }}>
              When connecting your Google account to Phloz, our access and use of Google user data is strictly governed by our{" "}
              <Link to="/privacy" style={{ color: "#2563eb", textDecoration: "underline" }}>
                Privacy Policy
              </Link>{" "}
              and the Google API Services User Data Policy, including Limited Use requirements. You retain full control over your Google authorization and may revoke access at any time through your Google Security Settings.
            </p>
          </section>

          <section style={{ marginBottom: "32px", lineHeight: "1.7" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>
              5. Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by applicable law, Phloz and TBP Labs shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service.
            </p>
          </section>

          <section style={{ lineHeight: "1.7" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", marginBottom: "12px" }}>
              6. Contact Information
            </h2>
            <p>
              For legal inquiries or questions concerning these Terms, please contact us at{" "}
              <a href="mailto:support@phloz.io" style={{ color: "#2563eb", textDecoration: "underline" }}>
                support@phloz.io
              </a>
              .
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer style={{ backgroundColor: "#ffffff", borderTop: "1px solid #e2e8f0", padding: "24px", textAlign: "center", fontSize: "13px", color: "#64748b" }}>
        <p>© 2026 Phloz by TBP Labs. All rights reserved. | <Link to="/privacy" style={{ color: "#64748b", textDecoration: "underline" }}>Privacy Policy</Link></p>
      </footer>
    </div>
  );
}

